exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line{stroke-width:2.5;fill:none}.line-group>path{fill:none;stroke-width:4}.text{font-size:12px}.title-text{font-size:16px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/MultiLineChart/multiLine.scss
// module id = 901
// module chunks = 0